import Image from 'next/image';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {MdIosShare} from 'react-icons/md';
import type {ColumnClip} from '..';
import {GSSKT_HOST} from '../../../../../config/constants/hosts';
import {cn} from '../../../../../lib/classname';
import {ShareButton} from '../../../../../shared/components/ShareButton';
import {formatDate} from '../../../../../shared/services/formatDate';
import {Clip} from './Clip';
import {Tag} from './Tag';

type BaseProps = {
  isSponsored: boolean;
  className?: string;
  title: string;
  coverImageURL?: string;
  tags: string[];
  clip: ColumnClip;
};
type Sponsored = BaseProps & {
  isSponsored: true;
  publishedAt: string;
  companyName: string;
};
type NotSponsored = BaseProps & {
  isSponsored: false;
  updatedAt: string;
};
type Props = Sponsored | NotSponsored;
export const Header: FC<Props> = (props) => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.asPath)}`;

  return (
    <div className={cn(props.className)}>
      {props.coverImageURL && props.coverImageURL !== '' && (
        <Image
          src={props.coverImageURL}
          alt={props.title}
          width={960}
          height={540}
          priority={true}
        />
      )}
      <div className="px-16 py-12 space-y-[12px] pc:grid pc:grid-cols-4 gap-[24px]">
        <div className="pc:col-span-3">
          <h1 className="font-bold text-[24px] leading-[26.4px] mb-12 pc:text-[36px] pc:leading-[64.8px]">
            {props.title}
          </h1>
          <div className="flex flex-wrap gap-8">
            {props.tags.map((tag) => (
              <Tag name={tag} key={tag} />
            ))}
            {props.isSponsored && !props.tags.includes('sponsored記事') && (
              <Tag name="sponsored記事" />
            )}
          </div>
        </div>

        <div className="pc:col-span-1">
          <div className="mb-8 flex flex-col gap-4 font-bold text-[16px]">
            {props.isSponsored && <p>Sponsored by {props.companyName}</p>}
            <p>
              {formatDate(
                props.isSponsored ? props.publishedAt : props.updatedAt,
              )}
            </p>
          </div>
          <div className="flex justify-end pc:justify-start items-center gap-12">
            <Clip
              isClipped={props.clip.isClipped}
              handleClip={props.clip.handleClip}
              count={props.clip.clipCount}
            />
            <ShareButton
              title={props.title}
              url={currentUrl}
              variant="white"
              className="flex items-center justify-center bg-black-5 rounded-full w-[36px] h-[36px] pc:w-[44px] pc:h-[44px] hover:opacity-70"
            >
              <MdIosShare size={24} color="#000" />
            </ShareButton>
          </div>
        </div>
      </div>
    </div>
  );
};
